import {Component, Input} from '@angular/core';
import {FormControl} from '@angular/forms';
import {MaterialModule} from '../../../../material.module';
import {
  PRODUCT_CARD_TEXT_FIELDS, ProductCardTextKey, ProductCardTextOverrides, ProductCardTexts,
  productCardTextLanguage
} from '../../../../models/product-card-texts.model';

@Component({
  selector: 'app-product-card-text-settings',
  standalone: true,
  imports: [MaterialModule],
  templateUrl: './product-card-text-settings.component.html',
  styleUrls: ['./product-card-text-settings.component.scss']
})
export class ProductCardTextSettingsComponent {
  @Input({required: true}) control!: FormControl<ProductCardTextOverrides>;
  @Input() locale = 'en-US';
  @Input() localeLabel = '';
  @Input() defaults: ProductCardTexts = {};
  readonly buttonFields = PRODUCT_CARD_TEXT_FIELDS.filter(field => field.group === 'buttons');
  readonly otherFields = PRODUCT_CARD_TEXT_FIELDS.filter(field => field.group === 'other');
  showOther = false;

  get language(): string { return productCardTextLanguage(this.locale); }
  get changedCount(): number {
    return Object.values(this.control.value?.[this.language] ?? {}).filter(text => text?.trim()).length;
  }
  value(key: ProductCardTextKey): string { return this.control.value?.[this.language]?.[key] ?? ''; }

  change(key: ProductCardTextKey, event: Event): void {
    this.setText(key, (event.target as HTMLInputElement).value);
  }

  setText(key: ProductCardTextKey, text: string): void {
    if (this.control.disabled) return;
    const texts = {...this.control.value?.[this.language]};
    if (text) texts[key] = text;
    else delete texts[key];
    this.control.setValue({...this.control.value, [this.language]: texts});
    this.control.markAsDirty();
    this.control.markAsTouched();
  }
}
